/* eslint-disable */
import { produce } from "immer";
import {
  ALL_DOCUMENTS_FETCH_START,
  ALL_DOCUMENTS_FETCH_SUCCESS,
  ALL_DOCUMENTS_FETCH_FAILURE,
} from "../actions/types";

const allDocumentReducer = (
  state = {
    // for all documents
    allDocumentsFetching: false,
    allDocumentsData: [],
    allDocumentsError: null,
  },
  action,
) => {
  switch (action.type) {
    // for all documents
    case ALL_DOCUMENTS_FETCH_START:
      return produce(state, (draft) => {
        draft.allDocumentsFetching = true;
      });
    case ALL_DOCUMENTS_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.allDocumentsFetching = true;
        draft.allDocumentsData = action.data;
        draft.allDocumentsFetching = false;
      });
    case ALL_DOCUMENTS_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.allDocumentsFetching = false;
        draft.allDocumentsError = action.error;
      });
    default:
      return state;
  }
};

export default allDocumentReducer;
